import { useBoard } from '@/hooks/boards-hooks';
import { useCurrentChannel } from '@/hooks/query/useCurrentChannel';
import { useFetchQueryParams } from '@/hooks/useFetchQueryParams';

export const useDetectChannelId = () => {
  /**
   * useDetectChannelId - This hook returns the channel_id, board_id mainly
   *
   * Based on routes, how we get these details might be different.
   *
   * For /feeds, /channels routes - we use the hooks
   * And others routes work through query params.
   *
   * Currently, we give precedence to query params if present. (But ideally there shouldn't be any discrepancy between them.)
   *
   */
  const { channel_id: boardChannelId, board_id: boardId } = useBoard();
  const { id: sharedWithMeChannelId } = useCurrentChannel();
  const channelId = boardChannelId ?? sharedWithMeChannelId;

  const {
    board_id: boardIdQueryParam,
    channel_id: channelIdQueryParam,
    global_channel_id: globalChannelId,
  } = useFetchQueryParams();

  const boardType: 'MY_FEED' | 'SHARED_WITH_ME' = boardId
    ? 'MY_FEED'
    : 'SHARED_WITH_ME';

  return {
    channelId: globalChannelId || channelIdQueryParam || channelId,
    boardType,
    boardId: boardIdQueryParam || boardId,
  };
};
